import React, { useEffect, useContext, useState } from 'react';
import { DeviceContext } from './DeviceContext';
import { useNavigate } from 'react-router-dom';
import { AppConstants } from '../model/enums';
// import { Device } from '../model/types';

type DeviceLoaderProps = {
  sessionId: string | null;
  docId: string | null;
  onLoaded: () => void; // Cihazlar yüklendiğinde çağrılacak prop
}

const DeviceLoader: React.FC<DeviceLoaderProps> = ({ sessionId, docId, onLoaded }) => {
  const deviceContext = useContext(DeviceContext);

  if (!deviceContext) {
    throw new Error('DeviceLoader must be used within a DeviceProvider');
  }
  const navigate = useNavigate();

  const { setTesisName, setDevices, setPages, setActivePage } = deviceContext;

  useEffect(() => {
    if (sessionId == null) return;
    const fetchDevices = async () => {
      try {
        const response = await fetch(`${AppConstants.url}/start-data/${docId}?mySession=${sessionId}`, {
          method: 'GET',
          credentials: 'include', // Session cookie'yi dahil etmek için
          // credentials: "same-origin"
        });

        // Hata durumlarını kontrol et: HTTP 200-299 değilse hata fırlat
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'An error occurred while fetching devices');
        }

        const clientWeb = await response.json();
        setTesisName(clientWeb.tesisName);
        setPages(clientWeb.pages);
        if (clientWeb.pages.length > 0) {
          setActivePage(clientWeb.pages[0].pageId);
        }
        setDevices(clientWeb.devices); // Cihazları context içine kaydet
        onLoaded();

      } catch (error: any) {
        console.error('Error fetching devices:', error);
        navigate('/error', { state: { message: error.message } });
      }
    };

    fetchDevices();
  }, [setDevices]);

  return null; // Bu bileşen arayüze bir şey döndürmüyor, sadece veri yüklüyor.
};

export default DeviceLoader;
